import appAxios from '..'
import { AUTORIZE_TRANSACTION } from '../constants'
import {
  ApiResultGeneric,
  AutorizeTransactionData,
  PaymentGatewayData,
} from './types'

const autorizeTransaction = async (
  data: AutorizeTransactionData
): Promise<ApiResultGeneric<PaymentGatewayData> | null> => {
  try {
    const result = await appAxios.post<ApiResultGeneric<PaymentGatewayData>>(
      AUTORIZE_TRANSACTION,
      data
    )

    return result.data
  } catch (err: any) {
    if (err.response) return err.response.data
    return null
  }
}

const paymentApi = {
  autorizeTransaction,
}

export default paymentApi
